import { Fragment, useEffect } from "react";
import { EuiSpacer, EuiText } from "@inscopix/ideas-eui";
import { FieldParamTable } from "../../fields/FieldParamTable";
import { FieldTableName } from "../../fields/FieldTableName";
import { ToolSpec } from "types/json-schemas/type_guards";

interface StepJoinColumnsProps {
  toolSpec: ToolSpec;
  paramKeys: { value: string[]; isDirty: boolean };
  setParamKeys: (paramKeys: string[], isDirty: boolean) => void;
  columnGroupName: { value: string; isDirty: boolean };
  setColumnGroupName: (columnGroupName: string, isDirty: boolean) => void;
}

export const StepJoinColumns = ({
  toolSpec,
  paramKeys,
  setParamKeys,
  columnGroupName,
  setColumnGroupName,
}: StepJoinColumnsProps) => {
  // Mark param keys as dirty when component to mounts
  useEffect(() => {
    if (!paramKeys.isDirty) {
      setParamKeys(paramKeys.value, true);
    }
  }, [paramKeys, setParamKeys]);

  return (
    <Fragment>
      <EuiText>
        <h4>Join analysis columns</h4>
      </EuiText>

      <EuiSpacer size="s" />

      <EuiText size="s">
        <p>
          Select which columns from the new analysis table should appear in your
          data table.
        </p>
      </EuiText>

      <EuiSpacer />

      <FieldTableName
        label="Column group name"
        placeholder=""
        value={columnGroupName.value}
        onChange={(field) => {
          setColumnGroupName(field.value, true);
        }}
      />

      <FieldParamTable
        toolSpec={toolSpec}
        value={paramKeys.value}
        onChange={(value) => {
          setParamKeys(value, true);
        }}
      />
    </Fragment>
  );
};
